/**
 * @generated SignedSource<<99caff06038c8f441ba29148014cc756>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LiquidGlassCard_brand$data = {
  readonly appConfig: {
    readonly buildTheme: {
      readonly id: string;
      readonly iosLiquidGlassEnabled: boolean;
      readonly iosLiquidGlassRequiresNewBuild: boolean;
    };
    readonly id: string;
  };
  readonly " $fragmentType": "LiquidGlassCard_brand";
};
export type LiquidGlassCard_brand$key = {
  readonly " $data"?: LiquidGlassCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"LiquidGlassCard_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LiquidGlassCard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigBuildThemeType",
          "kind": "LinkedField",
          "name": "buildTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "iosLiquidGlassEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "iosLiquidGlassRequiresNewBuild",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "59f8ca70f04815938f14d4f23b889e49";

export default node;
